export default __webpack_public_path__ + "static/media/image-ph-health-statistics-m.3f6134b3.webp";